import { render, staticRenderFns } from "./InsuranceBackedGuaranteesPage.vue?vue&type=template&id=898c8c1a&"
import script from "./InsuranceBackedGuaranteesPage.vue?vue&type=script&lang=js&"
export * from "./InsuranceBackedGuaranteesPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports